angular.module('rmDashboard')
	.service('dashboardSettings', require('./dashboardSettings'))
;
